import React from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import BusinessInvestmentView from './BusinessInvestmentView';

import { CompileTOVS } from "@app/utils/CompileTOVS";
import { saveAs } from "file-saver";
import { Packer } from "docx";
import { DocumentCreator } from "@app/utils/DocumentCreator";

class ConnectedBusinessInvestmentContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            locale: this.props.locale ? this.props.locale : 'en',
            pageLoad: '',
            // Business Investment
            internalResources: '',
            externalResources: '',
            existingAssets: '',
            validationErrors: {
                // Business Investment
                internalResources: { show: false, check: null, errorMessage: ''  },
                externalResources: { show: false, check: null, errorMessage: ''  },
                existingAssets: { show: false, check: null, errorMessage: ''  }
            },
            isLoading: false,
            errorMessage: '',
            successMessage: '',
            loadToSubmitTime: '',
            shareMessage: ''
        };
        // Business Investment
        this.handleInternalResources = this.handleInternalResources.bind(this);
        this.handleExternalResources = this.handleExternalResources.bind(this);
        this.handleExistingAssets = this.handleExistingAssets.bind(this);
        this.generateDoc = this.generateDoc.bind(this);
    }

    componentDidMount() {
        if (this.state.pageLoad === '') {
            this.setState({
                pageLoad: new Date().valueOf()
            });
        }
        for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).startsWith('tovsForm.investment.')) {
                this.setState({
                    [localStorage.key(i).substring(20)]: localStorage.getItem(localStorage.key(i))
                });
            }
        }
    }

    // Business Investment
    handleInternalResources(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        if (value.length === 0) {
            validationErrors.internalResources.show = true;
            validationErrors.internalResources.errorMessage = 'KEY SECTION! TRY NOT TO LEAVE BLANK ON YOUR APPLICATION FORM!';
            validationErrors.internalResources.check = false;
        } 
        else if (value.length < 32) {
            validationErrors.internalResources.show = true;
            validationErrors.internalResources.errorMessage = 'KEY SECTION! Have your suppliers, colleagues, etc. help you identify some internal resources.';
            validationErrors.internalResources.check = false;
            localStorage.setItem('tovsForm.investment.internalResources', value);
        }
        else {
            validationErrors.internalResources.show = false;
            validationErrors.internalResources.errorMessage = '';
            validationErrors.internalResources.check = true;
            localStorage.setItem('tovsForm.investment.internalResources', value);
        }
        this.setState({ 
            internalResources: value,
            validationErrors: validationErrors
        });
    }

    handleExternalResources(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        if (value.length === 0) {
            validationErrors.externalResources.show = true;
            validationErrors.externalResources.errorMessage = 'KEY SECTION! DO NOT LEAVE BLANK ON YOUR APPLICATION FORM!';
            validationErrors.externalResources.check = false;
        } 
        else if (value.length < 32) {
            validationErrors.externalResources.show = true;
            validationErrors.externalResources.errorMessage = 'KEY SECTION! Your supplier(s) can help you complete this section.';
            validationErrors.externalResources.check = false;
            localStorage.setItem('tovsForm.investment.externalResources', value);
        }
        else {
            validationErrors.externalResources.show = false;
            validationErrors.externalResources.errorMessage = '';
            validationErrors.externalResources.check = true;
            localStorage.setItem('tovsForm.investment.externalResources', value);
        }
        this.setState({ 
            externalResources: value,
            validationErrors: validationErrors
        });
    }

    handleExistingAssets(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        if (value.length === 0) {
            validationErrors.existingAssets.show = true;
            validationErrors.existingAssets.errorMessage = 'KEY SECTION! TRY NOT TO LEAVE BLANK ON YOUR APPLICATION FORM!';
            validationErrors.existingAssets.check = false;
        } 
        else if (value.length < 32) {
            validationErrors.existingAssets.show = true;
            validationErrors.existingAssets.errorMessage = 'KEY SECTION! Your supplier(s) can help you complete this section.';
            validationErrors.existingAssets.check = false;
            localStorage.setItem('tovsForm.investment.existingAssets', value);
        }
        else {
            validationErrors.existingAssets.show = false;
            validationErrors.existingAssets.errorMessage = '';
            validationErrors.existingAssets.check = true;
            localStorage.setItem('tovsForm.investment.existingAssets', value);
        }
        this.setState({ 
            existingAssets: value,
            validationErrors: validationErrors
        });
    }

    generateDoc() {
        const data = new CompileTOVS().compile(); 
        var documentCreator = new DocumentCreator();
        var doc = documentCreator.create(data);

        Packer.toBlob(doc).then(function (blob) {
            saveAs(blob, "TradingOnlineVoucherScheme-" + Date.now() + ".docx");
        });
    }

    generateViewProps() {
        return {
            ...this.state,
            handleOther: this.handleOther,
            // Business Investment
            handleInternalResources: this.handleInternalResources,
            handleExternalResources: this.handleExternalResources,
            handleExistingAssets: this.handleExistingAssets,
            generateDoc: this.generateDoc
        };
    }

    render() {
        const viewProps = this.generateViewProps();
        return (
            <BusinessInvestmentView {...viewProps} />
        );
    }
}

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLocale: locale => dispatch(setLocale(locale))
    };
};

const BusinessInvestmentContainer = injectIntl(connect(mapStateToProps,mapDispatchToProps)(ConnectedBusinessInvestmentContainer));

export default BusinessInvestmentContainer;